module.exports = __webpack_public_path__ + "static/media/5.fa2b4662.jpg";